//课程直播列表功能
import request from './request'

//课程创建
export function _audioList(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/course/audio',
    })
    return request(config)
}